
<template>
	<div>
		<draggable
			v-bind="dragOptions"
			tag="div"
			class="accordion"
			:list="list"
			:value="local_value"
			@input="emitter"
		>
			<b-card no-body :key="key" v-for="(el, key) in local_value">
				<template v-if="el != null" >
					<b-card-header header-tag="header" role="tab">
							<b-button v-b-toggle="'collapse_'+el.horse_id" class="text-left btn-block btn" >
								<font-awesome-icon :icon="['far', 'sort']" class="mr-2" />
								{{ el.label }}
								<router-link :to="{ name: 'HorseFicheInfo', params: {horse_id: parseInt(el.horse_id)} }" class="ml-2 float-right">
									<font-awesome-icon :icon="['fal', 'link']" />
								</router-link>
							</b-button>
	
					</b-card-header>
					<b-collapse v-bind:id="'collapse_'+el.horse_id" accordion="my-accordion" role="tabpanel">
						<b-card-body>
							<draggable 
							tag="table"
							class="table"
							v-model="el.details"
							>
								<tr  :key="key" v-for="(el, key) in el.details">
									<td class="col-1"><font-awesome-icon :icon="['far', 'sort']" class="mr-2" /></td>
									<td class="col-5">
										{{ el.articles.articles_label }}
									</td>
									<td class="col-2 text-right" >
										{{ el.invoicedetails_ht }}
									</td>
									<td class="col-4">
										<router-link v-if="el.contract.contract_num != null" :to="{ name: 'ContractFormv2', params: {contract_id: parseInt(el.contract.contract_id)} }" class="mr-2">
										#{{ el.contract.contract_num }} {{ el.contract.contract_config.horse.horse_nom }}
										</router-link>
										<span v-if="el.actes">{{ el.actes.actes_type.actestype_label }} ({{ formatDate(el.actes.actes_date) }})</span>
										<span v-if="el.pension">{{ el.pension.pension_label }} ({{ formatDate(el.pension.pension_periode.horsepensionperiode_start_date) }} - {{ formatDate(el.pension.pension_periode.horsepensionperiode_end_date) }})</span>
									</td>
								</tr>
							</draggable>
						</b-card-body>
					</b-collapse>
						<!-- <nested-details  v-bind:id="'collapse_'+el.horse_id" class="accordion-collapse collapse" :list="el.details" :parent="key" />  -->
					
				</template>
			</b-card>
		</draggable>
	</div>
</template>

<script>
import draggable from "vuedraggable";
export default {
	name: "nested-details",
	data () {
		return {
			local_value: null
		}
	},
	created() {
		this.local_value = this.value.filter(v => v)
	},
	methods: {
		emitter(value) {
			this.$emit("input", value);
		}		
	},
	components: {
		draggable
	},
	computed: {
		dragOptions() {
			return {
				animation: 0,
				group: "label",
				disabled: false,
				ghostClass: "ghost"
			};
		}
	},
	watch: {
		value: {
			handler(val) {
				this.local_value = val.filter(v => v)
			},
			deep: true
		},
	},
	props: {
		value: {
			required: false,
			type: [Array, Object],
			default: null
		},
		list: {
			required: false,
			type: [Array, Object],
			default: null
		},
		parent: {
			type: [Number],
			default: null
		}
	}
};
</script>